import type { IconSvgObject } from './types';

const Coordinate02Icon: IconSvgObject = [
  ["path", { d: "M13.5 2.5L12 4M12 4V6M12 4L10.5 2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 13H5.5L2.5 17H5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18.5 13.5L21.5 16.5M21.5 13.5L18.5 16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 8.5V16M12 16L3.5 21.5M12 16L20.5 21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Coordinate02Icon;
